const thumbs = document.querySelectorAll(".thumby");
const elIds = [];
thumbs.forEach((el) => elIds.push(el.dataset.image));

thumbs.forEach((el) => {
  el.addEventListener("mouseover", () => {
    elIds.forEach((id) => document.getElementById(id).classList.remove("show"));
    const pimg = document.getElementById(el.dataset.image);
    pimg.classList.add("show");
  });
  el.addEventListener("pointerdown", () => {
    elIds.forEach((id) => document.getElementById(id).classList.remove("show"));
    const pimg = document.getElementById(el.dataset.image);
    pimg.classList.add("show");
  });
});
